import DOMPurify from "dompurify";

export const sanitize = DOMPurify.sanitize.bind(DOMPurify);
